import { Fragment, type ReactNode } from "react";
import type { TFillRef } from "@libs/figure-spans";
import { FIGURE_KEY_ATTR, fillFigureText, splitFigureSpans } from "@/zapi-frontend/shared/lib/figureRefs";
import { useFigureRefs } from "./FigureRefsProvider";

// The dotted underline every trigger wears comes from the `[data-figure-key]` rule in styles.css,
// so a span the markdown carries and one React renders look the same.
export function FigureTrigger({ figureKey, children }: { figureKey: string | undefined; children: ReactNode }) {
  const refs = useFigureRefs();
  const figure = figureKey ? refs?.get(figureKey) : undefined;
  if (!figureKey || !figure) return children;
  return (
    <span {...{ [FIGURE_KEY_ATTR]: figureKey }} tabIndex={0} aria-haspopup="dialog">
      {children}
    </span>
  );
}

export function FigureText({ text, refs }: { text: string; refs: TFillRef[] | null | undefined }) {
  const figures = useFigureRefs();
  if (!refs?.length) return text;
  const filled = fillFigureText(text, refs, figures);
  if (!figures) return filled.text;
  return splitFigureSpans(filled.text, filled.refs, figures).map((part, index) =>
    part.key ? (
      <FigureTrigger key={index} figureKey={part.key}>
        {part.text}
      </FigureTrigger>
    ) : (
      <Fragment key={index}>{part.text}</Fragment>
    )
  );
}
